import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { GoogleLogin, useGoogleLogin, CredentialResponse, googleLogout, useGoogleAuth } from '@react-oauth/google';
import axios from "axios";
// @mui
import { LoadingButton } from '@mui/lab';
import { Stack, Button } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// components
import Iconify from '../../../components/iconify';
import { useAuthContext } from '../../../auth/useAuthContext';

// ----------------------------------------------------------------------

export default function AuthWithSocial({ clickLogin }) {


  const navigate = useNavigate();
  const { loginGoogleFB } = useAuthContext();
  const [islogin, setisLogin] = useState(false);
  const login = useGoogleLogin({
    onSuccess: async codeResponse => {
      handleSuccess(await codeResponse);
    },
    // flow: 'auth-code',
  });

  const handleSuccess = async (codeResponse) => {


    axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`, {
      headers: {
        Authorization: `Bearer ${codeResponse.access_token}`,
        Accept: 'application/json'
      }
    })
      .then((res) => {
        onSubmit(res.data);
      })
      .catch((err) => console.log(err));

  }

  const onSubmit = async (data) => {
    try {
      const resp = await loginGoogleFB(data.email, 2, data.id, data.family_name, data.given_name)
      if (resp !== false) {
        navigate("/")
      }
    }
    catch (error) {
      console.error(error);
    }
  };

  return (
    <Stack direction="row" spacing={2} >
      {
        islogin ?
          <LoadingButton
            loading
            loadingPosition="start"
            // startIcon={<SaveIcon />}
            style={{
              fontSize: '16px',
              border: 'none',
              borderRadius: '4px',
              width: '100%'
            }}
          >
            Loading
          </LoadingButton>
          :
          <Button fullWidth size="large" color="inherit" variant="outlined" onClick={() => login()} >
            <Iconify icon="logos:google-icon" width={24} sx={{ mr: 3 }} /> {" "} Sign in with Google
          </Button>
      }


      {/* <Button fullWidth size="large" color="inherit" variant="outlined">
        <Iconify icon="carbon:logo-facebook" width={24} sx={{ color: '#1877F2' }} />
      </Button>

      <Button color="inherit" fullWidth variant="outlined" size="large">
        <Iconify icon="carbon:logo-github" width={24} sx={{ color: 'text.primary' }} />
      </Button> */}
    </Stack>
  );
}

AuthWithSocial.propTypes = {
  clickLogin: PropTypes.func,
};